var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container pt-3" }, [
      _c(
        "div",
        {
          staticClass:
            "gv-container-header d-flex flex-column align-items-center pt-5 justify-content-center text-center",
        },
        [
          _c("h1", { staticClass: "display-1 text-muted pt-5" }, [
            _c("strong", [_vm._v("403")]),
          ]),
          _vm._v(" "),
          _c("h2", { staticClass: "title" }, [
            _c("strong", [_vm._v("Acceso denegado/prohibido")]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-muted" }, [
            _vm._v(
              "La página o el recurso al que intentabas acceder está absolutamente"
            ),
            _c("br"),
            _vm._v(" prohibido por alguna razón."),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }